/**
 * Thrown by the auth layer to signal "an interactive redirect has been kicked
 * off; stop processing this request/route." Lives outside auth.service and
 * user.service so both can reference it without a circular import.
 */
export class AuthRedirectInitiatedError extends Error {
  constructor() {
    super('Authentication redirect initiated');
    this.name = 'AuthRedirectInitiatedError';
  }
}
